import styled from '@emotion/styled'
import { AnimatePresence, motion } from 'framer-motion'
import { useCallback, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useUpdateEffect } from 'react-use'
import { useRecoilState, useRecoilValue } from 'recoil'
import { useDebouncedCallback } from 'use-debounce'

import coursewareNextImg from '@/assets/images/courseware-next.png'
import coursewarePrevImg from '@/assets/images/courseware-prev.png'
import defaultWhiteBoardImg from '@/assets/images/defaultWhiteBoard.png'
import labelIcon from '@/assets/images/label-icon.png'
import courseware1Img from '@/assets/images/room/page.png'
import webviewBg from '@/assets/images/webview_logo_bg.png'
import ImgPlaceholder from '@/components/ImgPlaceholder'
import Loadding from '@/components/Loadding'
import Modal from '@/components/Modal'
import useGetRecoilState from '@/hooks/useGetRecoilState'
import useGetState from '@/hooks/useGetState'
import { autoplayState, CoursewareList, coursewareListState, penStateState, VideoCoursewareList, videoCoursewareListState, viewPicIdIndexState, viewPicIdState } from '@/store/courseware'
import { bigTeaAScreenState, bigWinState, breadInClassInfoState, isTeaOnlineState, MiaobiMenu, miaobiMenuState, paramsState, restState, rtmReadyState } from '@/store/room'
import { Board, Conf, DrawLines } from '@/utils/board'

import { justStudentVideoBoard, justTeacherVideoBoard, mainStudentVideoBoard, mainTeacherVideoBoard, roomEvent, rtmClient, viceStudentVideoBoard, viceTeacherVideoBoard } from '../..'
import { position } from '../Video'
import Captions from './components/Captions'
import Game from './components/Game'
import Video from './components/Video'
import WebBrowser from './components/WebBrowser'

export const coursewareBoard = new Board()
export const safariWhiteBorad = new Board()

// 延迟初始化 boardToPrefix 对象以避免循环依赖问题
const getBoardToPrefix = (): { [preId: string]: Board } => ({
  10: mainTeacherVideoBoard,
  11: viceTeacherVideoBoard,
  12: justTeacherVideoBoard,
  20: mainStudentVideoBoard,
  21: viceStudentVideoBoard,
  22: justStudentVideoBoard
})

export const defAnimate = {
  initial: { opacity: 0, x: '-100px' },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: '-100px' },
  transition: {
    duration: 0.15,
    type: 'spring',
    damping: 35,
    stiffness: 600
  }
}

export default function Index() {
  const coursewareRef = useRef<HTMLDivElement>(null)
  const coursewareBoardRef = useRef<HTMLDivElement>(null)
  const safariWhiteBoradRef = useRef<HTMLDivElement>(null)
  const [draw, setDraw] = useState(0)
  const [coursewareBoxState, setCoursewareBoxState] = useState(false)
  const [loading, setLoading] = useState(false)
  const [oldVideoState, setOldVideoState] = useState(false)
  const [oldVideo, setOldVideo] = useState<VideoCoursewareList | null>(null)
  const [coursewareList, setCoursewareList, getCoursewareList] = useGetRecoilState(coursewareListState)
  const [videoCoursewareList, setVideoCoursewareList, getVideoCoursewareList] = useGetRecoilState(videoCoursewareListState)
  const [viewPicId, setViewPicId, getViewPicId] = useGetRecoilState(viewPicIdState)
  const viewPicIdIndex = useRecoilValue(viewPicIdIndexState)
  const params = useRecoilValue(paramsState)
  const [bigWin, setBigWin] = useRecoilState(bigWinState)
  const [autoplay, setAutoplay] = useRecoilState(autoplayState)
  const [rest, setRest] = useRecoilState(restState)
  const penState = useRecoilValue(penStateState)
  const [breadInClassInfo, setBreadInClassInfo] = useRecoilState(breadInClassInfoState)
  const [isTeaOnline, setIsTeaOnline] = useRecoilState(isTeaOnlineState)
  const [rtmReady, setRtmReady] = useRecoilState(rtmReadyState) // rtm是否准备好
  const bigTeaAScreen = useRecoilValue(bigTeaAScreenState)
  const [tab, setTab, getTab] = useGetState<'courseware' | 'webview'>('courseware') // courseware: 教室 url: webview
  const [miaobiMenu, setMiaobiMenu, getMiaobiMenu] = useGetRecoilState(miaobiMenuState)
  const [showSafariWhiteBorad, setShowSafariWhiteBorad] = useState<boolean>(false)
  // 白板 初始化、翻页
  useEffect(() => {
    roomEvent.on('rest-state', closeOldVideo)
    coursewareBoard.on('emitArtDrawLine', emitArtDrawLine)
    coursewareBoard.on('ready', ready)
    coursewareBoard.on('error', error)
    coursewareBoard.on('conf', boardConf)
    // safariWhiteBorad.on('emitArtDrawLine', emitArtDrawLine)
    // safariWhiteBorad.on('ready', ready)
    // safariWhiteBorad.on('error', error)
    // safariWhiteBorad.on('conf', boardConf)
    rtmClient.on('ArtDrawLine', onArtDrawLine)
    rtmClient.on('ArtConVideo', ArtConVideo)
    rtmClient.on('ArtVideoInfo', ArtVideoInfo)
    rtmClient.on('ArtPicSelecte', ArtPicSelecte)
    rtmClient.on('ArtWebViewControl', ArtWebViewControl)
    rtmClient.on('ArtSyncAllstate', ArtSyncAllstate)
    coursewareBoardRef.current && coursewareBoard.create(coursewareBoardRef.current)
    // setTimeout(() => {
    //   setMiaobiMenu([
    //     {
    //       title: '神笔马良',
    //       selectIndex: '0',
    //       load: true,
    //       selected: true,
    //       reload: 0,
    //       // stuUrl: new URL('http://localhost/ai-chat?courseid=1&id=1784062&role=student&room=555555&_t=1749128041.725550')
    //       stuUrl: new URL('https://test.ml.miaobi.cn/ai-chat?courseid=1&id=1784062&role=student&room=555555&_t=1749175124.090864')
    //     }
    //     // {
    //     //   title: '共创',
    //     //   selectIndex: '1',
    //     //   load: true,
    //     //   stuUrl: new URL('https://test.gc.miaobi.cn/board?id=1784062&role=student&room=555555&_t=1749180044.609213')
    //     // }
    //   ])
    //   setTab('webview')
    // }, 5000)
    return () => {
      roomEvent.removeListener('rest-state', closeOldVideo)
      coursewareBoard.removeListener('emitArtDrawLine', emitArtDrawLine)
      coursewareBoard.removeListener('ready', ready)
      coursewareBoard.removeListener('error', error)
      coursewareBoard.removeListener('conf', boardConf)
      rtmClient.removeListener('ArtDrawLine', onArtDrawLine)
      rtmClient.removeListener('ArtConVideo', ArtConVideo)
      rtmClient.removeListener('ArtVideoInfo', ArtVideoInfo)
      rtmClient.removeListener('ArtPicSelecte', ArtPicSelecte)
      rtmClient.removeListener('ArtWebViewControl', ArtWebViewControl)
      rtmClient.removeListener('ArtSyncAllstate', ArtSyncAllstate)
      coursewareBoard.destroy()
      safariWhiteBorad.destroy()
    }
  }, [])

  useEffect(() => {
    // 动画300ms
    setTimeout(() => {
      coursewareBoard._resize()
    }, 350)
    coursewareBoard.setConf({ tool: bigWin === 1 && !penState && !bigTeaAScreen ? 1 : 0 })
  }, [bigWin, bigTeaAScreen, penState])

  // 收到画线
  const onArtDrawLine = useCallback((memberId: string, payload: DrawLines) => {
    const { windowId } = payload
    const preId = windowId.slice(0, 2)
    let board: Board
    if (windowId === 'safariWhiteBoradUserId') {
      board = safariWhiteBorad
    } else if (windowId.length > 20 || windowId === 'default_disImage') {
      board = coursewareBoard
    } else {
      board = getBoardToPrefix()[preId]
    }
    board.addPartionLine(payload)
  }, [])

  const ArtConVideo = useCallback((memberId: string, payload: any) => {
    const { videoType, type } = payload
    // 关闭老视频
    if (type === 3) {
      setOldVideo(null)
    }
  }, [])

  const ArtVideoInfo = useCallback((memberId: string, payload: any) => {
    const { videoType, videoUrl } = payload
    // 关闭老视频
    if (videoType === 2) {
      setOldVideo({
        videoTitle: '',
        videoURL: videoUrl
      })
    }
  }, [])

  const ArtPicSelecte = useCallback((memberId: string, payload: any) => {
    const { images: imgs, videos } = payload
    let images = [...imgs]
    if (images.length) {
      const { picId: remotePicId, type } = images[0]
      const localCourse = getCoursewareList() || []
      const localVieoCourse = getVideoCoursewareList() || []
      const hasPicId = localCourse.find((e) => e.picId === remotePicId)
      const isCourseware = images.find((v) => v.type === 3) // 是否为课件
      if (type === 3 && hasPicId) return

      for (const imageItem of images) {
        imageItem.json = JSON.parse(imageItem.jsonConfig || '{}')
      }

      // todo loading
      // this.setToastType({ type: toastType.load })

      // 相同课件
      if (hasPicId) {
        // images.forEach((v) => classRoom.justScreen.emit('clear-line', { wid: v.picId })) todo
        const oldImages = [...localCourse]
        oldImages.splice(0, images.length, ...images)
        images = [...oldImages]
      } else if (images.length > 1 || isCourseware) {
        // 非相同课件且非一个课件，暂定认为是其他课件包，需要删除以前的课件包，保留历史图片，然后放入前面(type=1历史图片)
        const oldImages: CoursewareList[] = []
        localCourse.forEach((v) => {
          if (v.type === 1) {
            oldImages.push(v)
          } else {
            // classRoom.justScreen.emit('clear-line', { wid: v.picId }) todo
          }
        })
        // 可能存在学员先进教室，老师进来，学员的截图需要插入指定位置
        if (rest.state === 1 && oldImages.length) {
          images.splice(Math.max(0, breadInClassInfo.courseIndex - 1), 0, ...oldImages)
        } else {
          images = [...images, ...oldImages]
        }
      } else {
        // 上传图片课件或者选择图库课件
        images.unshift(...localCourse)
      }
      videos.unshift(...localVieoCourse)
      console.log('remotePicId', remotePicId)
      setCoursewareList(images)
      setVideoCoursewareList(videos)
      setViewPicId(remotePicId)
    }
  }, [])

  const ArtWebViewControl = useCallback((memberId: string, payload: any) => {
    const miaobiMenu: MiaobiMenu[] = getMiaobiMenu() ?? []
    console.log('🚀 ~ ArtWebViewControl ~ miaobiMenu:', miaobiMenu)
    console.log('payload', payload)
    const { controlType, currentUrl = '', selectIndex } = payload
    let stuUrl: URL | undefined = undefined

    const updateMiaoBiMenu = () => {
      const hasMenu = miaobiMenu.find((item) => item.selectIndex === selectIndex)
      stuUrl = currentUrl ? new URL(currentUrl) : undefined
      if (hasMenu) {
        const newMenu = [...miaobiMenu].map((item) => {
          if (item.selectIndex === selectIndex) {
            return { ...item, selectIndex, load: true, stuUrl, selected: true }
          }
          return { ...item, selected: false }
        })
        setMiaobiMenu(newMenu)
      } else {
        setMiaobiMenu([
          ...miaobiMenu.map((item) => ({ ...item, selected: false })),
          {
            selectIndex,
            load: true,
            stuUrl,
            reload: 0,
            selected: true
          }
        ])
      }
    }
    switch (controlType) {
      // @"打开" @"关闭" @"前进" @"后退" @"切换" @"添加" @"删除" @"刷新"
      case '打开': {
        const timer = setTimeout(() => {
          if (safariWhiteBoradRef.current) {
            safariWhiteBorad.create(safariWhiteBoradRef.current)
          }
          clearTimeout(timer)
        }, 500)
        setTab('webview')
        break
      }
      case '关闭':
        setTab('courseware')
        break
      case '添加': {
        updateMiaoBiMenu()
        break
      }
      case '输入': {
        updateMiaoBiMenu()
        break
      }
      case '切换': {
        const newMenu = [...miaobiMenu].map((item) => ({ ...item, selected: item.selectIndex === selectIndex }))
        setMiaobiMenu(newMenu)
        break
      }
      case '删除': {
        const newMenus = miaobiMenu.filter((item) => item.selectIndex !== selectIndex)
        const sortMenus = newMenus.map((item, index) => ({ ...item, selectIndex: `${index}`, selected: index === newMenus.length - 1 }))
        setMiaobiMenu([...sortMenus])
        break
      }
      case '前进':
        break
      case '后退':
        break
      case '刷新':
        setMiaobiMenu(miaobiMenu.map((item) => ({ ...item, reload: item.selectIndex === selectIndex ? Math.random() : item.reload })))
        break
      case '外部':
        stuUrl = new URL(currentUrl)
        window.open(stuUrl.toString(), '_blank')
        break
      case '内部':
        {
          const newMenu = [...miaobiMenu].map((item) => ({ ...item, title: item.selectIndex === selectIndex ? decodeURIComponent(currentUrl) : item.title }))
          setMiaobiMenu(newMenu)
        }
        break
      case '打开白板':
        {
          setShowSafariWhiteBorad(true)
          const timer = setTimeout(() => {
            if (safariWhiteBoradRef.current) {
              safariWhiteBorad.init({
                windowId: 'safariWhiteBoradUserId',
                url: defaultWhiteBoardImg
              })
            }
            clearTimeout(timer)
          }, 500)
        }
        break
      case '关闭白板':
        setShowSafariWhiteBorad(false)
        safariWhiteBorad.clear(7)
        break
      default:
        break
    }
  }, [])

  // 课间休息关闭老视频的2个弹窗
  const closeOldVideo = useCallback((state: boolean) => {
    if (state) {
      setOldVideoState(false)
      setOldVideo(null)
    }
  }, [])

  // 老视频课件 打开/关闭 信令
  useUpdateEffect(() => {
    if (oldVideo) {
      // rtmClient.sendMessage('ArtVideoInfo', {
      //   videoUrl: oldVideo.videoURL,
      //   videoType: 2
      // })
    } else {
      // rtmClient.sendMessage('ArtConVideo', {
      //   type: 3,
      //   timeStamp: +new Date() / 1000,
      //   videoType: 2
      // })
    }
  }, [oldVideo])

  // 课件准备好
  const ready = useCallback(() => {
    setLoading(false)
  }, [])

  // 课件有问题
  const error = useCallback((txt: string) => {
    toast.error(txt)
    setLoading(false)
  }, [])

  // 配置更新
  const boardConf = useCallback((conf: Conf) => {
    // console.log('boardConf', conf)
    setDraw(conf.tool)
  }, [])

  // 发送画线
  const emitArtDrawLine = useCallback((lineData: DrawLines) => {
    rtmClient.sendMessage('ArtDrawLine', { ...lineData })
  }, [])

  // 没有预览的课件时，选择第一个课件为预览课件
  useEffect(() => {
    if (viewPicId === 'default_disImage' && coursewareList.length) {
      setViewPicId(coursewareList[0].picId)
    }
  }, [viewPicId, coursewareList])

  // 渲染白板
  useEffect(() => {
    coursewareBoardRef.current && (coursewareBoardRef.current.innerHTML = '')
    initBoard({ viewPicId, viewPicIdIndex, coursewareList, bigWin })
  }, [viewPicId])

  const initBoard = useDebouncedCallback(({ viewPicId, viewPicIdIndex, coursewareList, bigWin }) => {
    console.log('initBoard', viewPicId, viewPicIdIndex, coursewareList, bigWin)
    const pic = coursewareList[viewPicIdIndex]
    // 如果找不到课件，初始化default_disImage
    if (!pic) {
      coursewareBoard.init({
        windowId: 'default_disImage',
        url: defaultWhiteBoardImg
      })
      if (rest.state !== 1) {
        coursewareBoard.setConf({ tool: bigWin === 1 && !penState ? 1 : 0 })
      }
    } else if (pic && pic.courseType === 1) {
      setLoading(true)
      coursewareBoard.init({
        windowId: pic?.picId,
        url: pic?.picUrl
      })
      if (rest.state !== 1) {
        coursewareBoard.setConf({ tool: bigWin === 1 && !penState ? 1 : 0 })
      }
    }
  }, 300)

  const coursewarePrev = () => {
    if (coursewareList[viewPicIdIndex - 1]) {
      const picId = coursewareList[viewPicIdIndex - 1].picId
      setViewPicId(picId)
      courseSelected(picId)
    }
  }

  const coursewareNext = () => {
    if (coursewareList[viewPicIdIndex + 1]) {
      const picId = coursewareList[viewPicIdIndex + 1].picId
      setViewPicId(picId)
      courseSelected(picId)
    }
  }

  // 课件列表 选择一页
  const checkCourseware = (picId: string) => {
    setViewPicId(picId)
    courseSelected(picId)
  }

  // 上一页、下一页、选择一页
  const courseSelected = (picId: string) => {
    const courseData = coursewareList.find((v) => v.picId === picId)
    if (courseData && rest.state !== 1) {
      const lines = coursewareBoard.getPageLines(picId)
      // rtmClient.sendMessage('ArtPicChange', {
      //   imageInfo: {
      //     ...courseData,
      //     zipUrl: courseData.zip,
      //     jsonConfig: JSON.stringify(courseData.json),
      //     lines
      //   }
      // })
    }
  }

  const showTime = () => {
    // if (rest.state === 0 && rest.onceRest) {
    //   toast('正在截图，无法切换窗口')
    //   return
    // }
    // setBigWin(1)
  }

  const course = coursewareList[viewPicIdIndex]

  // 课件背景图
  const bg = () => {
    if (rtmReady && !coursewareList.length) {
      if (isTeaOnline) {
        return 'bg-wait bg-courseware-wait-tips bg-[length:4vh]'
      } else {
        // return 'bg-courseware bg-cover'
        return 'bg-courseware-hk bg-cover'
      }
    }
  }

  const ArtSyncAllstate = useCallback((memberId: string, payload: DrawLines) => {
    // ArtSyncAllstate TODO 同步
    const miaobiMenu: MiaobiMenu[] = getMiaobiMenu() ?? []
    const tab = getTab()
    const isSelected = miaobiMenu.find((item) => item.selected)
    if (miaobiMenu.length == 0) {
      return
    }
    setTimeout(() => {
      rtmClient.sendMessage('ArtWebViewControl', {
        controlType: tab === 'courseware' ? '关闭' : '打开',
        selectIndex: '0'
      })

      miaobiMenu.forEach((item: any) => {
        rtmClient.sendMessage('ArtWebViewControl', {
          controlType: '添加',
          selectIndex: item.selectIndex
        })
        if (item.stuUrl) {
          rtmClient.sendMessage('ArtWebViewControl', {
            controlType: '输入',
            currentUrl: item.stuUrl?.toString(),
            selectIndex: item.selectIndex
          })
        }
        if (item.title) {
          rtmClient.sendMessage('ArtWebViewControl', {
            controlType: '内部',
            currentUrl: item.title,
            selectIndex: item.selectIndex
          })
        }
      })

      rtmClient.sendMessage('ArtWebViewControl', {
        controlType: '切换',
        selectIndex: isSelected?.selectIndex ?? '0'
      })
    }, 1500)
  }, [])

  useUpdateEffect(() => {
    if (tab === 'courseware') {
      // 动画300ms
      setTimeout(() => {
        coursewareBoard._resize()
      }, 350)
    } else {
      setTimeout(() => {
        safariWhiteBorad._resize()
      }, 350)
    }
  }, [tab])

  useEffect(() => {
    if (miaobiMenu.length && safariWhiteBoradRef.current) {
      console.log('safariWhiteBoradRef.current', safariWhiteBoradRef.current)
      // safariWhiteBorad.create(safariWhiteBoradRef.current)
      // safariWhiteBorad.init({
      //   windowId: 'safariWhiteBoradUserId',
      //   url: defaultWhiteBoardImg
      // })
    }
  }, [miaobiMenu])

  return (
    <Container ref={coursewareRef} className={`bg-[#0003] bg-no-repeat bg-center  ${bg()} ${position[bigWin]}`} onClick={showTime}>
      <div className={`bg-no-repeat bg-cover w-full h-full ${tab === 'courseware' ? 'block' : 'hidden'}`}>
        <img className="absolute left-0 top-0 z-[48] w-[6vh]" src={labelIcon} />
        {/* 提词器 zIndex=50 */}
        {bigWin === 1 ? <Captions /> : null}
        {/* 图片课件 */}
        <Loadding state={loading} className="bg-[rgba(0,0,0,0.3)]">
          <div
            ref={coursewareBoardRef}
            className={`${coursewareList.length && (!course || course.courseType !== 1) ? 'hidden' : ''} ${
              draw === 1 ? 'pen' : ''
            } ${draw === 1 ? 'brush-border-box' : ''} relative w-full h-full flex justify-center items-center overflow-hidden scrollbar-style`}
          ></div>
        </Loadding>
        {/* 视频课件 */}
        {course?.courseType === 2 && rest.state !== 1 ? <Video videoType={1} course={course} url={course.picUrl} poster={course.coverUrl} autoplay={autoplay} /> : null}
        {course?.courseType === 2 && rest.state === 1 ? <ImgPlaceholder className="w-full h-full" src={course.coverUrl} /> : null}
        {/* 互动课件 */}
        {course?.courseType === 3 ? <Game course={course} autoplay={autoplay} /> : null}

        {/* 课件页码 */}
        <AnimatePresence>
          {coursewareList.length && bigWin === 1 && rest.state === 1 && !rest.attendClassState ? (
            <motion.div {...defAnimate} style={{ left: 'calc(50% - 100px)' }} className=" absolute z-20 bottom-[15px] w-[200px] h-[26px] flex justify-center items-center gap-[8px]">
              <div className="h-full w-[25px]">
                <img onClick={coursewarePrev} className="anim_btn2" src={coursewarePrevImg} />
              </div>
              <div onClick={() => setCoursewareBoxState(true)} className="bg-[rgba(0,0,0,.3)] h-full w-[80px] flex justify-evenly items-center rounded-[6px] anim_btn2">
                <img className="w-[15px]" src={courseware1Img} />
                <span className="text-[14px] text-white">
                  {viewPicIdIndex + 1}/{coursewareList.length}
                </span>
              </div>
              <div className="h-full w-[25px]">
                <img onClick={coursewareNext} className="anim_btn2" src={coursewareNextImg} />
              </div>
              {/* {rest.state !== 1 && videoCoursewareList.length ? (
              <div className="h-full w-[25px]">
                <img onClick={() => setOldVideoState(true)} className="anim_btn2" src={videoBtnImg} />
              </div>
            ) : null} */}
            </motion.div>
          ) : null}
        </AnimatePresence>
        {/* 课件选择 */}
        <AnimatePresence>
          {coursewareBoxState && bigWin === 1 ? (
            <motion.div {...defAnimate} className=" absolute z-20 top-0 left-0 w-full h-full">
              <div onClick={() => setCoursewareBoxState(false)} className="w-full h-full absolute z-10 left-0 top-0"></div>
              <div className="bg-[rgba(0,0,0,.8)] absolute z-20 left-0 top-0 w-[140px] h-full text-[16px] overflow-y-auto overflow-x-hidden px-[10px] scrollbar-style">
                {coursewareList.map((v, i) => (
                  <div key={v.picId} className="my-[10px] flex flex-col justify-center items-center">
                    <div
                      onClick={() => checkCourseware(v.picId)}
                      className={`rounded w-[120px] h-[160px] overflow-hidden flex justify-center items-center ${
                        viewPicId === v.picId ? 'border border-[#ff3300]' : 'border border-[rgba(255,255,255,.1)]'
                      }`}
                    >
                      <ImgPlaceholder className="object-cover cursor-pointer" src={v.coverUrl || v.picUrl} />
                    </div>
                    <div className={`my-[10px] w-[30px] h-[30px] rounded-full flex justify-center items-center ${viewPicId === v.picId ? 'bg-[#ff3300] text-white' : 'bg-white'}`}>
                      {i < 9 ? '0' : ''}
                      {i + 1}
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          ) : null}
        </AnimatePresence>
        {/* 老视频课件列表 */}
        <Modal show={oldVideoState} footer="" title="视频课件" cancel={() => setOldVideoState(false)}>
          <div className="w-[400px] flex items-center justify-center flex-col">
            <AnimatePresence>
              {videoCoursewareList.map((v, i) => {
                return (
                  <motion.div
                    key={i}
                    onClick={() => {
                      setOldVideoState(false)
                      setTimeout(() => {
                        setOldVideo(v)
                      }, 300)
                    }}
                    className={`w-full h-[45px] relative cursor-pointer flex justify-center items-center gap-[10px] shadow-course p-[10px] my-[10px] rounded border-[2px] hover:shadow-course-hover border-[#FFF]`}
                    animate={{ opacity: 1, y: 0 }}
                    initial={{ opacity: 0, y: 10 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.15 }}
                  >
                    <div className="flex-1 w-0 h-full flex flex-col justify-start items-start gap-[5px]">
                      <div className={`text-[14px] text-[#333] w-full overflow-hidden truncate`}>
                        {i + 1}&ensp;{v.videoTitle}
                      </div>
                    </div>
                  </motion.div>
                )
              })}
            </AnimatePresence>
          </div>
        </Modal>
        {/* 老视频课件 */}
        <Modal show={!!oldVideo} footer="" title={oldVideo?.videoTitle} cancel={() => setOldVideo(null)}>
          <div className="w-[720px] h-[540px]">{oldVideo ? <Video videoType={2} course={oldVideo} url={oldVideo.videoURL} autoplay={false} /> : null}</div>
        </Modal>
        {/* 课中点评 */}
        {/* <CourseAssess /> */}
      </div>
      <WebBrowser show={tab === 'webview'} menus={miaobiMenu}>
        <div
          ref={safariWhiteBoradRef}
          className={`${showSafariWhiteBorad ? 'block' : 'hidden'} absolute left-0 top-0 z-11 w-full h-full flex justify-center items-center overflow-hidden scrollbar-style`}
        ></div>
      </WebBrowser>
    </Container>
  )
}

const Container = styled(motion.div)`
  .webview-logo-bg {
    background-image: url(${webviewBg});
    background-size: 30%;
    background-position: center;
    background-repeat: no-repeat;
  }
`
